import { MenuItem } from "@/app/ui/navigation/types";
import type { Location } from "vue-router";
import { dutySchemeType } from "@/components/pages/duty/composables/dutyConfiguration";
import type Guid from "@/app/types/common/guid";
import { LocalDate } from "@js-joda/core";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const dutyMenuSwedish = {
  root: "navigation_duty_group_sweden",
  dutyReturnList: "swedish_duty_return_list",
  dutyReturnListLocation: (): Location => ({
    name: dutyMenuSwedish.dutyReturnList,
  }),
  editReturn: "swedish_duty_edit_return",
  editReturnLocation: (id: Guid, isEditing: boolean): Location => ({
    name: dutyMenuSwedish.editReturn,
    params: {
      id: id.toString(),
      mode: isEditing ? "edit" : "view",
    },
  }),
  createReturn: "swedish_duty_create_return",
  createReturnLocation: (): Location => ({
    name: dutyMenuSwedish.createReturn,
  }),
  audit: "swedish_duty_audit_report",
  viewAudit: (fromDate: LocalDate, toDate: LocalDate): Location => ({
    name: dutyMenuSwedish.audit,
    params: {
      fromDateInclusive: fromDate.toString(),
      toDateInclusive: toDate.toString(),
    },
  }),
};

export const buildDutyMenuSwedishItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    name: dutyMenuSwedish.root,
    icon: "Assignment",
    visible: () =>
      dutySchemeType.value.isSweden() &&
      hasPermissionsUsingUserStore([EnumUserPermission.menuDutyView]),
    subMenus: [
      MenuItem.fromOpts({
        name: dutyMenuSwedish.dutyReturnList,
        url: "/duty/swedish/list",
        breadcrumbParentName: dutyMenuSwedish.root,
        view: () =>
          import(
            /* webpackChunkName: "swedish-duty" */ "@/components/pages/duty/swedish/ListSwedishDutyReturn.vue"
          ),
      }),
      MenuItem.fromOpts({
        name: dutyMenuSwedish.editReturn,
        url: "/duty/swedish/:id/:mode",
        breadcrumbParentName: dutyMenuSwedish.dutyReturnList,
        view: () =>
          import(
            /* webpackChunkName: "swedish-duty" */ "@/components/pages/duty/swedish/EditSwedishDutyReturn.vue"
          ),
        visible: false,
        componentProps: (route) => {
          return {
            id: route.params.id,
            editing:
              route.params.id &&
              route.params.mode.toLowerCase().trim() === "edit",
          };
        },
      }),
      MenuItem.fromOpts({
        name: dutyMenuSwedish.createReturn,
        url: "/duty/swedish/create",
        breadcrumbParentName: dutyMenuSwedish.dutyReturnList,
        view: () =>
          import(
            /* webpackChunkName: "swedish-duty" */ "@/components/pages/duty/swedish/EditSwedishDutyReturn.vue"
          ),
        visible: false,
        componentProps: (route) => ({
          editing: true,
        }),
      }),
      MenuItem.fromOpts({
        name: dutyMenuSwedish.audit,
        url: "/duty/swedish/audit",
        componentProps: (r) => ({
          fromDateInclusive:
            r.params.fromDateInclusive &&
            LocalDate.parse(r.params.fromDateInclusive),
          toDateInclusive:
            r.params.toDateInclusive &&
            LocalDate.parse(r.params.toDateInclusive),
        }),
        view: () =>
          import("@/components/pages/duty/swedish/SwedishDutyAudit.vue"),
      }),
    ],
  }),
];
